"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlackjackGameBuilder = void 0;
const blackjack_game_logic_1 = require("./blackjack-game-logic");
const board_1 = require("./board/board");
const player_piles_1 = require("./board/player-piles");
const card_1 = require("./card/card");
const card_index_mapping_1 = require("./card/card-index-mapping");
const pile_1 = require("./card/pile");
const logic_metrics_1 = require("./logic-metrics");
const logic_types_1 = require("./logic-types");
class BlackjackGameBuilder {
    static newGame(dealer, logicVersion) {
        const cardIndexMapping = new card_index_mapping_1.CardIndexMapping();
        const board = BlackjackGameBuilder.createBoard(cardIndexMapping);
        return new blackjack_game_logic_1.BlackjackGameLogic(dealer, cardIndexMapping, board, logicVersion);
    }
    static createBoard(cardIndexMapping) {
        const deck = this.createDeck(logic_types_1.PileId.Deck, cardIndexMapping);
        const croupier = this.createPile(logic_types_1.PileId.Croupier);
        const waste = this.createPile(logic_types_1.PileId.Waste);
        const playerPiles = new player_piles_1.PlayerPiles(this.createPile(logic_types_1.PileId.Player1), this.createPile(logic_types_1.PileId.Player2), this.createPile(logic_types_1.PileId.Player3), this.createPile(logic_types_1.PileId.Player4));
        return new board_1.Board(deck, croupier, playerPiles, waste);
    }
    static createDeck(pileId, cardIndexMapping) {
        const pile = new pile_1.Pile(pileId);
        const totalCards = logic_metrics_1.LogicMetrics.DeckCards * logic_metrics_1.LogicMetrics.NumberDecks;
        cardIndexMapping.resetDeck();
        for (let index = 0; index < totalCards; ++index) {
            const card = new card_1.Card(index, cardIndexMapping, false, false);
            pile.addCard(card);
        }
        return pile;
    }
    static createPile(pileId) {
        return new pile_1.Pile(pileId);
    }
}
exports.BlackjackGameBuilder = BlackjackGameBuilder;
